export default "__VITE_ASSET__DJ03e4Y7__"